// Generated by CoffeeScript 2.7.0
var CascadedSelectContainer;

import CascadedSelectsList from './cascaded_selects_list.js';

import EditCascadedSelectChoiceModal from '../cascaded_selects_modal/edit_cascaded_select_choice_modal.js';

import EditCascadedSelectChoicesModal from '../cascaded_selects_modal/edit_cascaded_select_choices_modal.js';

export default CascadedSelectContainer = Vue.extend({
  components: {
    'cascaded-selects-list': CascadedSelectsList
  },
  props: {
    initialCascadedSelect: {
      type: Object
    }
  },
  data: function() {
    return {
      cascadedSelect: this.initialCascadedSelect
    };
  },
  template: `<div class="cascaded-select-container">
  <div class="list-title">
    <div class="head">{{ cascadedSelect.name }}</div>
    <div class="labels">{{ labels }}</div>
  </div>
  <div class="list-content cascaded-trees">
    <div class="list-head mt-4 mb-4"
         v-if="cascadedSelect.labels.length >= 1">
      <button class="text-btn btn-primary"
              @click="openEditChoiceModalFunc">
        <i class="slp-plus-circle"></i>
        <span>新增选项</span>
      </button>
      <button class="text-btn btn-primary ml-6"
              @click="openAddNewChoicesFunc">
        <i class="slp-plus-circle-batch"></i>
        <span>批量新增选项</span>
      </button>
    </div>
    <cascaded-selects-list :initialCascadedSelectId="cascadedSelect.id"
                           :maxLabelLength="cascadedSelect.labels.length"
                           ref="cascadedSelectsListRef" />
  </div>
</div>`,
  created: function() {
    return Turbolinks.clearCache();
  },
  computed: {
    labels: function() {
      if (this.cascadedSelect.labels.length > 0) {
        return `(${this.cascadedSelect.labels.join('/')})`;
      } else {
        return '';
      }
    }
  },
  methods: {
    openAddNewChoicesFunc: function() {
      return new EditCascadedSelectChoicesModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('add-cascaded-select-choices-modal'),
        propsData: {
          title: '批量新增选项',
          cascadedSelectId: this.cascadedSelect.id,
          parentId: null,
          callback: (data) => {
            return this.$refs.cascadedSelectsListRef.hierarchy.addNodes(data);
          }
        }
      });
    },
    openEditChoiceModalFunc: function() {
      return new EditCascadedSelectChoiceModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('edit-cascaded-select-choice-modal'),
        propsData: {
          cascadedSelectId: this.cascadedSelect.id,
          title: '新增选项',
          callback: (cascadedSelectChoice) => {
            return this.$refs.cascadedSelectsListRef.hierarchy.addNodes([cascadedSelectChoice]);
          }
        }
      });
    }
  }
});
